module.exports = __webpack_public_path__ + "img/알케미스트.eb607661.png";